import React, { SyntheticEvent, useRef } from 'react';
import { MenuItem, MenuWindow } from '@app/core';
import { LogicJumpActionType } from 'queries';
import { useTranslation } from 'react-i18next';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { LogicJumpOption } from './interface';
import { QuestionNumber } from './QuestionNumber';
import { StopIconWithBg } from './StopIconWithBg';

const useStyles = createUseStyles((theme: Theme) => ({
  answerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase + 'px',
    paddingLeft: theme.marginBase,
    paddingRight: theme.marginBase,
  },
  defaultLabel: {
    ...theme.fonts.caption,
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  anchorElmnt: Element | null;
  onChange: (newOption: LogicJumpOption) => any;
  onClose: () => any;
  logicJumpOptions?: Array<LogicJumpOption>;
  selectedLogicJumpOption?: LogicJumpOption;
  defaultLabel?: boolean;
}

export const LogicChoiceSelector = ({
  anchorElmnt,
  onChange,
  onClose,
  logicJumpOptions,
  selectedLogicJumpOption,
  defaultLabel,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const onCloseSelector = (event: SyntheticEvent) => {
    event.stopPropagation();
    onClose();
  };

  const idRef = useRef(`dots_menu_${Math.random()}`);

  return (
    <MenuWindow
      open={!!anchorElmnt}
      onClose={onCloseSelector}
      onClick={onCloseSelector}
      anchorEl={anchorElmnt}
      id={idRef.current}
    >
      {logicJumpOptions?.map((option) => {
        const { toFieldId, label, number, type } = option;
        const selected =
          toFieldId === selectedLogicJumpOption?.toFieldId &&
          type === selectedLogicJumpOption?.type;

        return (
          <MenuItem
            value={option}
            key={`${toFieldId}_${label}`}
            selected={selected}
            onSelect={onChange}
          >
            <div className={classes.answerContainer}>
              <>
                {type === LogicJumpActionType.END_FORM && (
                  <StopIconWithBg isRound />
                )}
                {number !== undefined && (
                  <QuestionNumber number={number} small />
                )}
                <span>
                  {defaultLabel ? option.labelDefault || label : label}
                </span>
              </>
            </div>
          </MenuItem>
        );
      })}
    </MenuWindow>
  );
};
